export default __webpack_public_path__ + "static/media/Pool Water.f1211bfd.jpg";